// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"403":"263a42ca","440":"01089926","815":"b8262700"}[chunkId] + ".chunk.js";
};